export default class Track {
    constructor(option) {
        this.apiManager = option.apiManager;
    }
    send(data) {
        return this.apiManager.sendTracking(data);
    }
}
